module.exports = __webpack_public_path__ + "static/media/sannsyn.5fe14b93.mp3";